import React, { Component } from 'react';
import {Button, Card, Col, Form, Icon, Input, Row, Switch, Cascader} from "antd";
import Simple from './Table';
import { connect } from "react-redux";

import{
  fetchProduct
} from "appRedux/actions/Product";

class Product extends Component {

  componentDidMount() {
    this.props.fetchProduct();
  }


  render ( ) {
    return (
        <Simple/>
    );
  }
}

export default connect(null, { fetchProduct })(Product);



// WEBPACK FOOTER //
// ./src/routes/main/Products/index.js